import { useCallback, useState } from 'react';
export const useTransactionStepper = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const nextStep = useCallback((incr = 1) => {
        setCurrentStep((prev) => prev + incr);
    }, []);
    const prevStep = useCallback((incr = -1) => {
        setCurrentStep((prev) => prev + incr);
    }, []);
    const resetStepper = useCallback(() => {
        setCurrentStep(0);
    }, []);
    return {
        currentStep,
        nextStep,
        prevStep,
        resetStepper,
    };
};
//# sourceMappingURL=useTransactionStepper.js.map